import classNames from 'classnames';
import '../../style.scss';
import { IContentNav } from '../../../../model/api-modules/document';
import menuDown from '../../../../assets/images/menu-down.png';
import { useEffect } from 'react';

interface IProps {
  readonly itemData: IContentNav;
  readonly itemKey: string;
  readonly setActiveId: (value: string) => void;
  readonly activeId: string;
  readonly onSelectMenu: (id: number) => void;
  readonly isOpenList: number[];
}

export const RightCatalogueItem = (props: IProps) => {
  useEffect(() => {
    const scrollCheck = () => {
      const sections: NodeListOf<HTMLElement> = document.querySelectorAll(
        '.right-section-item'
      );
      let scrollItem: any;
      sections.forEach((section) => {
        const top = section.offsetTop + 120;
        const scrollPosition = window.scrollY;

        if (scrollPosition >= top) {
          scrollItem = section;
        }
      });
      if (scrollItem) {
        const navItem = document.getElementById(`menu-${scrollItem.id}`);
        // 判断该菜单存在再选中
        if (navItem) {
          props.setActiveId(navItem.id);
        }
      }
    };
    window.addEventListener('scroll', scrollCheck);
    return () => window.removeEventListener('scroll', scrollCheck);
  }, []);
  const onClickAnchor = (id: string, hashAnchorPoint: string) => {
    const hashAnchorPointDom = document.getElementById(hashAnchorPoint);
    if (hashAnchorPointDom) {
      const scrollPosition = hashAnchorPointDom.offsetTop;
      location.hash = hashAnchorPoint;
      window.scrollTo({ left: 0, top: scrollPosition + 120 });
    }
    props.setActiveId(id);
  };

  const onClickExpand = (e: React.MouseEvent<HTMLDivElement>, id: number) => {
    e.stopPropagation();
    props.onSelectMenu(id);
  };

  const decodeEntities = (encodedString: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(encodedString, 'text/html');
    return doc.body.textContent || '';
  };

  return (
    <li key={props.itemKey}>
      <a
        className={classNames(
          'right-menu-item',
          props.activeId === `menu-${props.itemData.domId}` ? 'activeLink' : '',
          Array.isArray(props.itemData.children) &&
            props.itemData.children.length > 0
            ? 'has-children'
            : '',
          Array.isArray(props.itemData.children) &&
            props.isOpenList.indexOf(props.itemData.id) === -1
            ? 'is-open'
            : ''
        )}
        id={`menu-${props.itemData.domId}`}
        // href={`#${item.domId}`}
        onClick={() =>
          onClickAnchor(`menu-${props.itemData.domId}`, props.itemData.domId)
        }
      >
        <span>{decodeEntities(props.itemData.title || '')}</span>
        {Array.isArray(props.itemData.children) &&
          props.itemData.children.length > 0 && (
            <img
              src={menuDown}
              onClick={(e) => onClickExpand(e, props.itemData.id)}
            />
          )}
      </a>
      <ul className="a-list">
        {Array.isArray(props.itemData.children) &&
          props.itemData.children.length > 0 &&
          props.itemData.children.map((it: IContentNav, idx: number) => {
            return (
              <RightCatalogueItem
                itemData={it}
                itemKey={`${props.itemKey}${idx}`}
                setActiveId={props.setActiveId}
                activeId={props.activeId}
                onSelectMenu={props.onSelectMenu}
                isOpenList={props.isOpenList}
              />
            );
          })}
      </ul>
    </li>
  );
};
